// extracted by mini-css-extract-plugin
module.exports = {"wiki_upper":"wiki_wiki_upper__141F4","wiki_img":"wiki_wiki_img__3UF0s","wiki_info":"wiki_wiki_info__13rkF","wiki_lower_images":"wiki_wiki_lower_images__1v8JW"};